export const MEMBERSHIP_CONTRACT_ADDRESS_SAI_LONG = import.meta.env
  .VITE_MEMBERSHIP_CONTRACT_ADDRESS_SAI_LONG;
export const ADMIN_WALLET_ADDRESS = import.meta.env.VITE_ADMIN_WALLET_ADDRESS;
export const CHECKIN_CONTRACT_ADDRESS_SAI_LONG = import.meta.env
  .VITE_CHECKIN_CONTRACT_ADDRESS_SAI_LONG;
export const EXCHANGE_CONTRACT_ADDRESS = import.meta.env.VITE_EXCHANGE_CONTRACT;
